import { __assign } from "tslib";
import * as React from 'react';
import { forwardRef, memo } from 'react';
var Google = memo(forwardRef(function (props, ref) { return (React.createElement("svg", __assign({ viewBox: "0 0 32 32", xmlns: "http://www.w3.org/2000/svg", ref: ref }, props),
    React.createElement("path", { d: "M2.667 20.421 6.864 28l8.148-14.527-4.321-7.579-8.025 14.527zm10.494 0L8.964 28h16.173l4.197-7.579H13.161zM20.197 4h-8.395l8.518 15.158h8.395L20.197 4z" }))); }));
Google.displayName = 'Google';
Google['iconName'] = 'google';
export default Google;
